import { GraduationCap, Calendar, MapPin } from 'lucide-react';
import { Education } from '../../types';

interface EducationSectionProps {
  education: Education[];
}

export default function EducationSection({ education }: EducationSectionProps) {
  return (
    <section className="bg-gray-50 py-12 dark:bg-gray-900">
      <div className="container">
        <h2 className="mb-6 text-2xl font-bold text-gray-900 dark:text-gray-50">Education</h2>
        <div className="space-y-4">
          {education.map(edu => (
            <div key={edu.id} className="card">
              <div className="mb-2 flex items-start gap-3">
                <GraduationCap className="mt-1 flex-shrink-0 text-primary-600" size={24} />
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 dark:text-gray-50">{edu.degree}</h3>
                  <p className="text-primary-600 dark:text-primary-400">{edu.institution}</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{edu.field}</p>
                  
                  <div className="mt-2 flex flex-wrap gap-3 text-sm text-gray-600 dark:text-gray-400">
                    <span className="flex items-center gap-1">
                      <Calendar size={14} />
                      {edu.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <MapPin size={14} />
                      {edu.location}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
